<template>
    <div component="Winlist">
        <page-header :icon="'equalizer'" :text="'WINNING RATING'" :hasCloseButton="true"></page-header>
        <section container="detail">
            <scroll-table v-if="getActor" :list="getActorWinList" :config="getActorStatsTableConfig"></scroll-table>
        </section>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import PageHeader from '@/components/Profile/ProfileDetailHeader.vue';
import ScrollTable from '@/components/.global/ScrollTable/ScrollTable.vue';

export default {
    name: 'Winlist',

    components: {
        PageHeader,
        ScrollTable,
    },

    computed: {
        ...mapGetters(['getActor', 'getActorStatsTableConfig', 'getActorWinList']),
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';

[component='Winlist'] {
    [container='detail'] {
        padding-top: 15px;
    }
}
</style>
